import React, { createRef } from 'react';
import classNames from 'clsx';
import CommentQuestionOutline from 'mdi-material-ui/CommentQuestionOutline';
import ArrowUp from 'mdi-material-ui/ArrowUp';

import { agencyMode } from 'app/services/env.service';
import { useStyles } from './QuestionsAndAnswers.styles';
import { ButtonLabelEnum } from 'app/shared/enums';
import { NewButton } from 'app/components/NewButton';
import { ScrollService } from 'app/services/scroll.service';
import { QuestionsAndAnswersProps } from './QuestionsAndAnswers.interfaces';
import { WarrantyInfo } from 'app/components/WarrantyInfo';

function QuestionsAndAnswers(props: QuestionsAndAnswersProps) {
  const classes = useStyles();
  const rootElement = createRef<HTMLDivElement>();

  if (agencyMode) {
    return null;
  }

  return (
    <div>
      <div className={classes.warrantyAndPaymentListWrapper}>
        <div className={classes.warrantyContainer}>
          <WarrantyInfo />
        </div>
      </div>
      <div className={classes.root} ref={rootElement}>
        <div className={'sekcja3'}>
          <div className={classes.descriptionContainer}>
            <h3 className={classes.expandableContentSectionHeader4}>
              Dobrze, że wybrałeś(aś) kalkulator OC i&nbsp;AC Mubi
            </h3>
            <div className={classes.sectionContainer}>
              <p>
                Kalkulator OC i&nbsp;AC Mubi prezentuje wyłącznie aktualne
                oferty OC i&nbsp;OC+AC wraz z&nbsp;dodatkowymi polisami
                dobrowolnymi – NNW, assistance czy ubezpieczeniem szyb lub opon.
                <br />
                <br />
                Oferty ubezpieczeń dostępne w&nbsp;kalkulatorze OC AC są
                ofertami firm ubezpieczeniowych, a&nbsp;ich ceny są wyliczane
                przez towarzystwa na podstawie danych wprowadzonych
                w&nbsp;formularzu przez użytkownika serwisu.
                <br />
                <br />
                Współpracujemy z&nbsp;renomowanymi firmami ubezpieczeniowymi,
                w&nbsp;tym ERGO Hestia, UNIQA, LINK4, PZU, Generali czy Allianz.
                <br />
                <br />
                Ubezpieczenie auta można kupić online lub telefonicznie
                w&nbsp;szybkim i&nbsp;bezpiecznym procesie. Jeśli zmienisz
                zdanie, od umowy ubezpieczenia zawartej online lub telefonicznie
                możesz odstąpić w&nbsp;ciągu 30 dni od jej zawarcia.
              </p>
            </div>
          </div>
        </div>
        <div
          className={classNames(
            classes.descriptionContainer,
            classes.fullWidth
          )}
        >
          <h2
            className={classes.expandableContentSectionHeader2}
            id={'questionsAndAnswersSection'}
          >
            <CommentQuestionOutline className={classes.icon} />
            Najczęstsze pytania o&nbsp;kalkulator OC i&nbsp;AC
          </h2>
          <div
            className={classNames(
              classes.descriptionBox,
              classes.withBorderTop
            )}
          >
            <h2 className={classes.expandableContentSectionHeader3}>
              Jak działa kalkulator OC i&nbsp;AC Mubi?
            </h2>
            <p className={classes.expandableContentSectionParagraph}>
              Nasz kalkulator OC i&nbsp;AC jest zaawansowanym narzędziem, które
              na podstawie informacji podanych przez Ciebie w&nbsp;formularzu,
              zbiera i&nbsp;prezentuje oferty towarzystw ubezpieczeniowych
              współpracujących z&nbsp;Mubi. Dzięki wypełnieniu formularza
              otrzymujesz przegląd ofert ubezpieczeniowych, oszczędzasz swój
              czas i&nbsp;pieniądze. Za pomocą kalkulatora ubezpieczeń Mubi
              możesz kupić polisę OC lub zapisać wyniki kalkulacji na później.{' '}
              <span className={classes.textBold}>
                Jeśli pozostawisz swój e&#8209;mail, wyniki wyślemy na Twoją
                skrzynkę pocztową.{' '}
              </span>
              Jeśli masz wątpliwości co do wyników porównania lub nie wiesz, jak
              wypełnić formularz,{' '}
              <span className={classes.textBold}>
                skontaktuj się z&nbsp;naszym doradcą pod numerem telefonu:
                22&nbsp;22&nbsp;10&nbsp;100.
              </span>
            </p>
          </div>
          <div
            className={classNames(
              classes.descriptionBox,
              classes.withBorderTop
            )}
          >
            <h2 className={classes.expandableContentSectionHeader3}>
              Jak skorzystać z&nbsp;kalkulatora OC Mubi krok po kroku?
            </h2>
            <p className={classes.expandableContentSectionParagraph}>
              Żeby ubezpieczyciele mogli przygotować dla Ciebie oferty, muszą
              zaczerpnąć kilku informacji o&nbsp;Tobie jako właścicielu
              i&nbsp;kierowcy (oraz o&nbsp;ewentualnych pozostałych
              właścicielach i&nbsp;kierowcach), a&nbsp;także
              o&nbsp;ubezpieczanym pojeździe i&nbsp;sposobie jego użytkowania.
              Dlatego pierwszym krokiem do zakupu ubezpieczenia OC online jest
              wypełnienie formularza. Na podstawie Twoich odpowiedzi na pytania
              ubezpieczyciele przygotują propozycje, z&nbsp;którymi zapoznasz
              się w&nbsp;kolejnym kroku. Oferty w&nbsp;kalkulatorze OC Mubi są
              prezentowane na liście, a&nbsp;najbardziej interesujące pakiety
              możesz dodać do porównania w&nbsp;przejrzystej tabeli.
              <br />
              <br />
              Wariant, który wybierzesz, możesz rozbudować o&nbsp;dodatkowe
              formy ochrony w&nbsp;kolejnym kroku. W&nbsp;zależności od
              ubezpieczyciela znajdziesz tam np.&nbsp;ubezpieczenie szyb,
              ubezpieczenie opon, ochronę prawną i&nbsp;inne, którymi uzupełnisz
              ubezpieczenie OC i&nbsp;AC.
              <br />
              <br />
              Zanim sfinalizujesz zakup i&nbsp;opłacisz składkę, podaj swoje
              dane, które będą niezbędne do wystawienia polisy. Tę, wraz
              z&nbsp;innymi potrzebnymi dokumentami ubezpieczeniowymi, otrzymasz
              na maila.
            </p>
          </div>
          <div className={classes.sectionContainer}>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy muszę podawać swoje dane w&nbsp;kalkulatorze OC Mubi?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Żeby uzyskać wiarygodne porównanie ofert ubezpieczeniowych,
                musisz podać prawidłowe informacje o&nbsp;pojeździe
                i&nbsp;osobie ubezpieczającej w&nbsp;formularzu kalkulatora OC.
                Informacje, o&nbsp;które pytamy, mogą wydawać się bardzo
                szczegółowe. Są jednak wymagane przez towarzystwa
                ubezpieczeniowe przy zakupie polis komunikacyjnych, a&nbsp;więc{' '}
                <a
                  className={classes.link}
                  href="https://mubi.pl/ubezpieczenie-oc/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  ubezpieczenia OC
                </a>{' '}
                i&nbsp;
                <a
                  className={classes.link}
                  href="https://mubi.pl/ubezpieczenie-ac/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  ubezpieczenia AC
                </a>
                .
                <br />
                <br />
                Niektóre firmy ubezpieczeniowe wymagają podania danych osobowych
                już na etapie kalkulacji (imię, nazwisko, PESEL). Bez nich
                towarzystwa te nie będą mogły zweryfikować Twojej historii
                ubezpieczeniowej w&nbsp;UFG, a&nbsp;tym samym nie będą
                w&nbsp;stanie przygotować dla Ciebie ofert. Wiele zakładów
                ubezpieczeń na etapie kalkulacji składki nie potrzebuje jednak
                Twoich personaliów. Jeśli zdecydujesz się na zakup pakietu,
                brakujące dane podasz na dalszym etapie. Będą potrzebne do
                wystawienia polisy.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy moje dane w&nbsp;kalkulatorze OC Mubi są bezpieczne?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Tak, dane podawane w&nbsp;formularzu kalkulatora OC AC Mubi są
                chronione przed dostępem niepowołanych osób. Na bezpieczeństwo
                przesyłanych danych ma wpływ m.in.&nbsp;infrastruktura
                techniczna, procedury wewnętrzne organizacji, certyfikat SSL czy
                wykorzystywanie bezpiecznych płatności online. Dane są
                wykorzystywane wyłącznie do przedstawienia oferty ubezpieczenia
                oraz w&nbsp;procesie jego zakupu i&nbsp;nie są przekazywane
                żadnym podmiotom poza firmami ubezpieczeniowymi. Dokładne
                informacje na ten temat znajdziesz w&nbsp;naszym{' '}
                <a
                  className={classes.link}
                  href="https://mubi.pl/regulamin/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  regulaminie
                </a>{' '}
                i&nbsp;
                <a
                  className={classes.link}
                  href="https://mubi.pl/polityka-prywatnosci/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  polityce prywatności
                </a>
                .
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Z&nbsp;jakimi firmami współpracuje Mubi?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Mubi.pl współpracuje z&nbsp;wiodącymi firmami ubezpieczeniowymi
                na polskim rynku, np.&nbsp;ERGO Hestia, LINK4, PZU, UNIQA,
                mtu24.pl, Allianz czy Proama. Grono współpracujących towarzystw
                stale się powiększa. Mamy ambicje porównywać ubezpieczenia OC AC
                wszystkich firm ubezpieczeniowych.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Jakie ubezpieczenia komunikacyjne znajdę w&nbsp;kalkulatorze
                Mubi?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Kalkulator OC i&nbsp;AC Mubi przedstawi Ci oferty ubezpieczeń
                komunikacyjnych, które zawierają przede wszystkim ochronę
                w&nbsp;ramach obowiązkowego ubezpieczenia OC. Możesz kupić samo
                OC lub uzupełnić obowiązkową ochronę o&nbsp;dodatki.
                W&nbsp;pakietach są dostępne: assistance, NNW i&nbsp;autocasco.
                <br />
                <br />
                Wybrany pakiet możesz jeszcze rozbudować o&nbsp;dodatkowe
                ubezpieczenia w&nbsp;kolejnym etapie zakupu. Wielu
                ubezpieczycieli daje możliwość uzupełnienia polisy
                m.in.&nbsp;o&nbsp;ubezpieczenie szyb, ubezpieczenie opon czy
                ochronę prawną.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy korzystanie z&nbsp;kalkulatora OC Mubi jest płatne?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Nasza{' '}
                <a
                  className={classes.link}
                  href="https://mubi.pl/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  porównywarka OC
                </a>{' '}
                to narzędzie, z&nbsp;którego możesz korzystać całkowicie za
                darmo. To prosty i&nbsp;wygodny sposób na znalezienie najlepszej
                oferty, bez ukrytych opłat i&nbsp;zbędnych formalności!
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy Mubi to wiarygodna firma?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Właścicielem porównywarki Mubi jest internetowy Agent
                Ubezpieczeniowy Sp.&nbsp;z&nbsp;o.o., wpisany do Rejestru
                Agentów Ubezpieczeniowych prowadzonego przez Komisję Nadzoru
                Finansowego. Nasza firma posiada licencję na sprzedaż
                ubezpieczeń. Mubi zaufał także znany rajdowiec Krzysztof
                Hołowczyc, a&nbsp;także piłkarze: Matty Cash, Kuba
                Błaszczykowski i&nbsp;Łukasz Piszczek, którzy zdecydowali się
                zostać ambasadorami marki.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Dlaczego warto kupić ubezpieczenie OC i&nbsp;AC za pomocą
                kalkulatora OC Mubi?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Zakup ubezpieczenia za pomocą kalkulatora OC/AC to wygodny
                i&nbsp;szybki sposób na tanie i&nbsp;korzystne ubezpieczenie.
                Dzięki porównaniu propozycji wielu ubezpieczycieli –
                współpracujemy już z&nbsp;około 20 firmami ubezpieczeniowymi –
                możesz szybko i&nbsp;bez wysiłku porównać pakiety ubezpieczenia
                OC i&nbsp;AC. Nie musisz kilkakrotnie wypełniać formularza na
                różnych stronach ani poszukiwać aktualnych promocji.
                <br />
                <br />
                Szybki proces porównania to także szybki zakup. Za polisę
                zapłacisz online i&nbsp;otrzymasz ją na swój adres e&#8209;mail.
                W&nbsp;ten sposób oszczędzisz nie tylko swój czas, ale także
                pieniądze.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Ile trwa obliczenie składki OC na Mubi.pl?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Gdy wypełnisz formularz, kalkulator OC i&nbsp;AC Mubi będzie
                potrzebował chwili, żeby zebrać oferty od ubezpieczycieli. Może
                to potrwać około 30 sekund, ale często użytkownicy otrzymują
                oferty już po kilku-, kilkunastu sekundach.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Ile mam czasu na wybór oferty od chwili obliczenia składki?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Na wybór oferty masz tyle czasu, ile potrzebujesz. Nikt nie
                będzie Cię poganiał, a&nbsp;sesja nie wygaśnie, jeśli będziesz
                chciał spędzić więcej czasu na porównywaniu pakietów. Możesz też
                podać adres e&#8209;mail. Wówczas link do listy ofert
                z&nbsp;kalkulatora otrzymasz na swoją skrzynkę i&nbsp;będziesz
                mógł wrócić do niej w&nbsp;późniejszym czasie.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                W&nbsp;jaki sposób kalkulator Mubi prezentuje ceny
                w&nbsp;porównaniu ofert ubezpieczenia OC?
              </h2>
              <div className={classes.expandableContentSectionParagraph}>
                W&nbsp;kalkulatorze OC oferty wyświetlamy w&nbsp;formie listy,
                którą możesz sortować i&nbsp;filtrować według własnych potrzeb,
                np.&nbsp;wyświetlić tylko pakiety z&nbsp;ubezpieczeniem AC lub
                ułożyć listę od najtańszych wariantów do najdroższych. Na liście
                przy każdej ofercie znajdziesz informację&nbsp;o:
                <ul>
                  <li>
                    towarzystwie ubezpieczeniowym, które oferuje dany pakiet,
                  </li>
                  <li>
                    zakresie ochrony (ubezpieczenie OC wraz z&nbsp;dodatkami),
                  </li>
                  <li>
                    szczegółach dotyczących najważniejszych usług w&nbsp;ramach
                    assistance,
                  </li>
                  <li>cenie pakietu.</li>
                </ul>
                W&nbsp;kalkulatorze OC i&nbsp;AC Mubi znajdziesz też opcję
                wyświetlenia szczegółów oferty. Wówczas pokaże się karta
                z&nbsp;większą ilością danych. Możesz też dodać kilka ofert do
                porównania. Takie zestawienie zobaczysz w&nbsp;czytelnej tabeli,
                która ułatwi Ci porównanie wybranych wariantów.
              </div>
            </div>
          </div>
          <h2 className={classes.expandableContentSectionHeader2}>
            <CommentQuestionOutline className={classes.icon} />
            Pytania o&nbsp;dane osobowe w&nbsp;kalkulatorze ubezpieczeń
            samochodowych Mubi.pl
          </h2>
          <div className={classes.sectionContainer}>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Dlaczego kalkulator OC AC Mubi pyta o&nbsp;PESEL? Czemu warto go
                podać i&nbsp;czy to bezpieczne?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Dzięki numerowi PESEL firmy ubezpieczeniowe weryfikują historię
                szkód w&nbsp;Ubezpieczeniowym Funduszu Gwarancyjnym (UFG).
                Niektórzy ubezpieczyciele bez podania numeru PESEL nie są
                w&nbsp;stanie zaproponować ubezpieczenia, dlatego wpisany PESEL
                zwiększa liczbę ofert, które otrzymasz.
                <br />
                <br />
                Podając swój numer w&nbsp;kalkulatorze OC, uzyskujesz bardziej
                kompleksowe porównanie i&nbsp;większą pewność, że zostało ono
                wykonane prawidłowo. Jeśli ubezpieczyciel zweryfikuje Twoją
                historię ubezpieczeniową, przygotuje lepiej dopasowaną ofertę
                zarówno pod względem zakresu ochrony, jak i&nbsp;ceny
                ubezpieczenia. Niestety zgodnie z&nbsp;prawem nie można zawrzeć
                umowy ubezpieczenia bez numeru PESEL, dlatego konieczne jest
                wpisanie go na etapie zakupu polisy.
                <br />
                <br />
                Twój numer PESEL jest u&nbsp;nas absolutnie bezpieczny.
                Wszystkie dane wpisane przez Ciebie w&nbsp;formularzu są
                chronione tajemnicą, a&nbsp;zasady ich przetwarzania
                i&nbsp;przechowywania znajdziesz w&nbsp;
                <a
                  className={classes.link}
                  href="https://mubi.pl/polityka-prywatnosci/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  polityce prywatności
                </a>{' '}
                i&nbsp;
                <a
                  className={classes.link}
                  href="https://mubi.pl/regulamin/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  regulaminie serwisu
                </a>
                .
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Czy muszę podawać numer telefonu i&nbsp;adres e&#8209;mail?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Podanie numeru telefonu i&nbsp;adresu e&#8209;mail jest
                dobrowolne. Jeśli podasz nam swój adres e&#8209;mail, będziemy
                mogli przesłać Ci np.&nbsp;podsumowanie kalkulacji, do której
                możesz wrócić jednym kliknięciem. Zapamiętamy Twoje dane
                i&nbsp;nie będziesz musiał po raz kolejny wypełniać formularza.
                Możemy również przypomnieć o&nbsp;końcu twojego okresu
                ubezpieczeniowego, dzięki czemu nie przegapisz końca ochrony
                ubezpieczeniowej.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Jeśli podam numer telefonu, czy będą do mnie dzwonić firmy
                z&nbsp;ofertami?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Podanie numeru telefonu jest dobrowolne, podobnie jak wyrażenie
                zgody na przetwarzanie danych w&nbsp;celach marketingowych. Nie
                udostępnimy Twojego numeru telefonu żadnej firmie
                ubezpieczeniowej bez Twojej zgody. Dokładne informacje
                o&nbsp;zasadach wykorzystania podanych przez Ciebie danych
                znajdziesz w&nbsp;naszej&nbsp;
                <a
                  className={classes.link}
                  href="https://mubi.pl/polityka-prywatnosci/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  polityce prywatności
                </a>{' '}
                i&nbsp;
                <a
                  className={classes.link}
                  href="https://mubi.pl/regulamin/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  regulaminie serwisu
                </a>
                .
              </p>
            </div>
          </div>
          <h2 className={classes.expandableContentSectionHeader2}>
            <CommentQuestionOutline className={classes.icon} />
            Pytania o&nbsp;dane kierowcy i&nbsp;właściciela samochodu
            w&nbsp;kalkulatorze OC Mubi
          </h2>
          <div className={classes.sectionContainer}>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Jestem współwłaścicielem pojazdu - czy mogę wyliczyć składkę OC
                za pomocą kalkulatora?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Tak, w&nbsp;naszym kalkulatorze możesz samodzielnie obliczyć
                składkę ubezpieczenia OC dla pojazdu, który dzielisz
                z&nbsp;drugim współwłaścicielem. Wykonując kalkulacje, zaznacz
                opcję współwłasności pojazdu i&nbsp;podaj niezbędne dane. Dzięki
                temu wyliczenie będzie wiarygodne, a&nbsp;Ty otrzymasz cenę
                uwzględniającą historię ubezpieczeniową tak Twoją, jak
                i&nbsp;współwłaściciela pojazdu.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Jak weryfikowane są dane o&nbsp;mojej historii ubezpieczenia?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Dane o&nbsp;Twoich dotychczasowych ubezpieczeniach są
                weryfikowane w&nbsp;UFG – Ubezpieczeniowym Funduszu
                Gwarancyjnym. Przechowuje on informacje o&nbsp;zawartych umowach
                ubezpieczeniowych, ale także zaistniałych szkodach. Nawet jeśli
                nie podasz informacji o&nbsp;spowodowanym wypadku lub stłuczce,
                a&nbsp;widnieje ona w&nbsp;UFG, wpłynie to na wysokość
                zaproponowanej przez towarzystwo składki ubezpieczenia. Swoją
                historię ubezpieczeniową możesz również zweryfikować w&nbsp;UFG
                samodzielnie.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Dlaczego firmy ubezpieczeniowe pytają o&nbsp;stan cywilny?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Statystycznie osoby w&nbsp;związkach małżeńskich jeżdżą
                bezpieczniej i&nbsp;powodują mniej wypadków. Z&nbsp;tego powodu
                przyznaje im się zniżkę na składkę ubezpieczenia. Informacja ta
                ma wpływ na wynik porównania, jaki uzyskasz, a&nbsp;wszystkie
                pytania pojawiające się w&nbsp;formularzu znajdują się także
                w&nbsp;formularzach towarzystw ubezpieczeniowych. Statystycznie
                osoby pozostające w&nbsp;związkach małżeńskich płacą za
                ubezpieczenie OC o&nbsp;kilka procent mniej niż pozostali.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Dlaczego firmy ubezpieczeniowe pytają o&nbsp;dzieci?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Podobnie jak w&nbsp;przypadku pytań o&nbsp;stan cywilny, fakt
                posiadania dzieci wpływa na wysokość składki ubezpieczeniowej.
                Firmy ubezpieczeniowe biorą pod uwagę statystyki mówiące, że
                osoby posiadające dzieci jeżdżą wolniej i&nbsp;ostrożniej.
                W&nbsp;efekcie powodują mniej szkód. Mogą więc płacić za
                ubezpieczenie mniej. Podając prawdziwe informacje na temat stanu
                cywilnego i&nbsp;faktu posiadania potomstwa, obniżasz swoją cenę
                OC.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Wiek kierowcy a&nbsp;cena ubezpieczenia – dlaczego to ma
                znaczenie?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Firmy ubezpieczeniowe szacują ryzyko spowodowania szkód, biorąc
                pod uwagę konkretny profil kierowcy. Młodzi kierowcy, ze względu
                na mniejsze doświadczenie za kółkiem oraz brawurę, częściej są
                sprawcami zdarzeń drogowych. Statystycznie to oni najczęściej
                powodują wypadki. Dlatego większość firm podwyższa składki
                młodym i&nbsp;niedoświadczonym kierowcom.
                <br />
                <br />
                Kim jest młody kierowca? To osoba, która ma mniej niż 28 lat
                (w&nbsp;zależności od firmy ubezpieczeniowej może być to
                przedział między 26 a&nbsp;30 lat) albo posiada prawo jazdy
                krócej niż 3&nbsp;lata.
                <br />
                <br />
                Niektórzy ubezpieczyciele mają specjalne oferty dla młodych
                kierowców lub przygotowują pakiety ubezpieczeniowe wyłącznie
                z&nbsp;myślą o nich. Przykładem towarzystwa, które oferuje
                ubezpieczenia samochodu osobom poniżej 30.&nbsp;roku życia, jest
                firma You Can Drive. Oferty tego ubezpieczyciela również
                znajdziesz w&nbsp;porównywarce Mubi.
              </p>
            </div>
          </div>
          <h2 className={classes.expandableContentSectionHeader2}>
            <CommentQuestionOutline className={classes.icon} />
            Pytania o&nbsp;samochód w&nbsp;kalkulatorze OC Mubi
          </h2>
          <div className={classes.sectionContainer}>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Dopiero planuję zakup auta. Czy mogę policzyć, ile zapłacę za
                ubezpieczenie OC?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Tak, możesz obliczyć składkę dla auta, które dopiero zamierzasz
                kupić. Kalkulator OC AC Mubi wymaga podania marki, modelu
                i&nbsp;pojemności silnika pojazdu oraz Twoich danych. Pamiętaj,
                że wyliczenie to ma charakter orientacyjny, a&nbsp;oferta jest
                ważna na moment wyliczenia. Jeśli będziesz chciał ubezpieczyć to
                auto po zakupie, cena może się różnić od tej uzyskanej
                w&nbsp;aktualnym wyliczeniu. Wahania składki nie są jednak duże
                i&nbsp;zwykle, jeśli nie zmieniły się dane i&nbsp;historia
                ubezpieczeniowa osoby wykonującej wyliczenie, nie przekraczają
                kilku procent.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Dlaczego firmy ubezpieczeniowe pytają o&nbsp;młodszego
                użytkownika samochodu?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Według policyjnych statystyk kierowcy w&nbsp;wieku od 18 do 24
                lat powodują najwięcej śmiertelnych wypadków – głównie przez
                skłonność do nadmiernej prędkości. Przez to kierowcy w&nbsp;tej
                grupie wiekowej są obarczeni zwyżkami. Młodzi kierowcy płacą za
                ubezpieczenie OC więcej, stąd częsta praktyka dopisywania do
                dowodu rejestracyjnego bardziej doświadczonego współwłaściciela
                samochodu, który ma już wypracowane zniżki. Firmy
                ubezpieczeniowe pytają o&nbsp;młodszego użytkownika pojazdu, aby
                właściwie obliczyć ryzyko wypadku. Koniecznie podaj te dane.
                W&nbsp;przeciwnym razie narazisz się na rekalkulację składki.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Jak marka i&nbsp;model samochodu wpływają na cenę ubezpieczenia
                OC i AC?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                Statystyki wypadków pokazują, że marka i&nbsp;model samochodu
                oraz pojemność silnika/moc mają wpływ na liczbę szkód
                i&nbsp;skłonność do ryzyka na drodze. To dlatego właściciele
                uznawanych za najszybsze i&nbsp;najchętniej wybierane przez
                młodszych kierowców marek, płacą za ubezpieczenie OC więcej niż
                pozostali. Wśród droższych w&nbsp;ubezpieczaniu marek są
                Lamborghini, Ferrari, Rolls&#8209;Royce czy Bentley, ale także
                bardziej popularne BMW i&nbsp;AUDI. Znacznie mniej zapłacą
                właściciele aut marki DACIA, SUZUKI, KIA.
                <br />
                <br />
                Natomiast przy wyliczaniu stawki autocasco ubezpieczyciel
                określa wartość pojazdu wraz z&nbsp;wyposażeniem i&nbsp;sprawdza
                statystyki kradzieżowe konkretnego modelu samochodu. Tu trudno
                oszacować dokładnie, które marki będą miały wyższe składki za
                AC. Pewne jest jednak, że im wyższa wartość pojazdu, tym wyższa
                będzie składka.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h3 className={classes.expandableContentSectionHeader3}>
                Jakie rodzaje pojazdów ubezpieczę w&nbsp;kalkulatorze OC
                i&nbsp;AC Mubi?
              </h3>
              <p className={classes.expandableContentSectionParagraph}>
                W&nbsp;kalkulatorze OC i&nbsp;AC Mubi możesz ubezpieczyć
                samochody osobowe i&nbsp;ciężarowe o&nbsp;masie do 3,5&nbsp;t,
                a&nbsp;także motocykle. Pojazdy mogą być używane prywatnie lub
                w&nbsp;ramach 1&#8209;osobowej działalności gospodarczej.
                Ponadto mogą to być maszyny maksymalnie 50&#8209;letnie, ale
                zarejestrowane na białych tablicach. Jeśli masz pytania lub nie
                możesz znaleźć swojego modelu w&nbsp;formularzu, skontaktuj się
                z&nbsp;naszym doradcą, dzwoniąc pod numer
                22&nbsp;22&nbsp;10&nbsp;100.
              </p>
            </div>
          </div>
          <h2 className={classes.expandableContentSectionHeader2}>
            <CommentQuestionOutline className={classes.icon} />
            Pytania o&nbsp;obliczanie składki w&nbsp;kalkulatorze OC Mubi
          </h2>
          <div className={classes.sectionContainer}>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Jak obliczyć składkę ubezpieczenia OC w&nbsp;kalkulatorze Mubi?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Żeby obliczyć składkę w&nbsp;kalkulatorze OC Mubi, musisz
                odpowiedzieć na kilka pytań dotyczących pojazdu, sposobu jego
                użytkowania, a&nbsp;także podać kilka informacji na swój temat
                i&nbsp;swojego doświadczenia za kółkiem. To na ich podstawie
                ubezpieczyciele wyliczają składkę ubezpieczenia OC
                i&nbsp;przygotują dla Ciebie oferty. Przypomnij sobie zatem
                najważniejsze informacje lub przygotuj dowód rejestracyjny
                pojazdu.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy po porównaniu cen polis muszę dokonać zakupu?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Nie. Porównanie składek ubezpieczeń nie zobowiązuje Cię do
                kupienia ubezpieczenia za pośrednictwem kalkulatora OC AC. Gdy
                porównasz oferty, możesz zapisać wyniki i&nbsp;wrócić do zakupu
                w&nbsp;dogodnym dla Ciebie terminie. Twoje kalkulacje zapiszemy
                i&nbsp;wyślemy na podany przez Ciebie adres e&#8209;mail. Jeśli
                masz wątpliwości co do wykonanego porównania lub potrzebujesz
                wsparcia w&nbsp;procesie zakupu, na każdym etapie możesz
                skontaktować się z&nbsp;naszym doradcą pod numerem telefonu
                +48&nbsp;(22)&nbsp;22&nbsp;10&nbsp;100.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy po obliczaniu składki ubezpieczenia samochodu mogę kupić je
                w&nbsp;pełni przez internet?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Jak najbardziej. Cały proces zakupu ubezpieczenia OC wykonasz
                w&nbsp;kalkulatorze OC i&nbsp;AC Mubi. Narzędzie przeprowadzi
                Cię od wypełnienia formularza, przez porównanie, po płatność
                przelewem internetowym. Po opłaceniu składki polisę otrzymasz na
                podany przez Ciebie adres e&#8209;mail. Kalkulator OC powstał po
                to, aby ułatwić kierowcom zakup polisy bez konieczności
                wychodzenia z&nbsp;domu lub z&nbsp;innego, dowolnego miejsca.
                Umożliwia ponadto nabycie obowiązkowego OC nie tylko
                w&nbsp;ciągu tygodnia, ale także w&nbsp;niedziele i&nbsp;święta.
                Pomaga tym samym uniknąć przerwy w&nbsp;ubezpieczeniu OC
                i&nbsp;kary za jego brak.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Skąd biorą się ceny prezentowane w&nbsp;kalkulatorze OC?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Ceny ubezpieczeń w&nbsp;kalkulatorze Mubi są pobierane
                z&nbsp;baz firm ubezpieczeniowych. Składki są obliczane na
                podstawie danych z&nbsp;formularza kwotacyjnego. Są to
                rzeczywiste kwoty, które uzyskujemy od firm ubezpieczeniowych
                i&nbsp;w większości wypadków, jeśli nie zmieniają się dane
                podane w&nbsp;formularzu, są to kwoty transakcyjne, czyli takie,
                za jakie możesz faktycznie kupić ubezpieczenie w&nbsp;danym
                towarzystwie. Jeśli nie jesteś zadowolony z&nbsp;wyników
                porównania, skontaktuj się z&nbsp;naszym doradcą, który
                zweryfikuje dane wpisane przez Ciebie w&nbsp;formularzu
                i&nbsp;sprawdzi, czy nie możemy zaproponować Ci tańszej oferty
                ubezpieczenia. Pomoc uzyskasz, dzwoniąc pod numer:
                +48&nbsp;(22)&nbsp;22&nbsp;10&nbsp;100.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Jak mogę zapłacić za ubezpieczenie?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Możesz skorzystać z&nbsp;błyskawicznych płatności lub zrobić
                przelew tradycyjny, kopiując wskazane dane i&nbsp;kwotę do
                zapłaty w&nbsp;pola w&nbsp;Twoim koncie bankowym. Możesz również
                skorzystać z&nbsp;płatności za pomocą BLIK.
                <br />
                <br />
                W&nbsp;wielu firmach ubezpieczeniowych kupisz OC i&nbsp;AC na
                raty. Ubezpieczyciele, którzy umożliwiają rozłożenie płatności
                na części, najczęściej oferują płatność składki w&nbsp;2 lub
                4&nbsp;ratach. Niektóre towarzystwa ubezpieczeniowe
                współpracujące z&nbsp;Mubi pozwalają na zakup polisy OC
                i&nbsp;AC w&nbsp;6 lub nawet 10 ratach.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy ubezpieczenia OC i&nbsp;AC są obowiązkowe?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Ubezpieczenie OC jest obowiązkowe. Kierowcom, którzy go nie
                mają, grożą surowe{' '}
                <a
                  className={classes.link}
                  href="https://mubi.pl/poradniki/kara-za-brak-oc/"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  kary za brak OC
                </a>
                . Ubezpieczenie odpowiedzialności cywilnej musisz mieć, nawet
                jeśli nie poruszasz się pojazdem lub jest on zepsuty.
                <br />
                <br />
                Ubezpieczenie AC jest ubezpieczeniem dobrowolnym. Warto rozważyć
                jego zakup, kiedy wartość pojazdu jest znacząca. Ubezpieczenie
                to chroni Cię przed finansowymi skutkami kradzieży pojazdu, jego
                uszkodzenia z&nbsp;Twojej winy lub wtedy, kiedy zostanie on
                uszkodzony przez nieznanego sprawcę.
                <br />
                <br />
                Autocasco jest najczęściej sprzedawane wraz z&nbsp;OC, podobnie
                jak inne ubezpieczenia dobrowolne, i&nbsp;zakup w&nbsp;takiej
                formie jest zwykle najbardziej opłacalny. Sprawdź ceny pakietów
                OC+AC w&nbsp;porównywarce Mubi!
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Co grozi za brak ważnego ubezpieczenia OC?
              </h2>
              <div className={classes.expandableContentSectionParagraph}>
                Ubezpieczenie OC jest obowiązkowe. Obowiązek jego posiadania
                reguluje prawo. Tym samym za brak tej polisy grożą kary
                finansowe nakładane przez UFG. I&nbsp;to niemałe kary. Ich
                wysokość zależy od minimalnego wynagrodzenia, które obowiązuje
                w&nbsp;okresie, w&nbsp;którym samochód był nieubezpieczony.
                <br />
                <br />
                Właściciele pojazdów osobowych, którzy zapomną o&nbsp;zakupie
                ubezpieczenia OC, zapłacą zatem grzywnę równą nawet dwukrotności
                minimalnej pensji. Właściciele samochodów ciężarowych, autobusów
                i&nbsp;ciągników samochodowych zapłacą jeszcze więcej, bo
                maksymalnie trzykrotność minimalnego wynagrodzenia. Mniej, bo
                ⅓&nbsp;minimalnej krajowej zapłacą właściciele innych pojazdów,
                np.&nbsp;motocykli.
                <br />
                <br />
                Wysokość kary za brak ubezpieczenia OC jest zależna również od
                czasu przerwy w&nbsp;ubezpieczeniu. Osoby, które nie miały OC:
                <ul>
                  <li>od 1 do 3&nbsp;dni, zapłacą 20% pełnej opłaty,</li>
                  <li>od 4 do 14&nbsp;dni, zapłacą 50% pełnej opłaty,</li>
                  <li>powyżej 14&nbsp;dni, zapłacą 100% należności.</li>
                </ul>
                Poza karą nakładaną przez UFG brak ubezpieczenia OC może nieść
                także inne konsekwencje. Dużo bardziej odczuwalna dla kieszeni
                kierowcy będzie sytuacja, w&nbsp;której w&nbsp;okresie przerwy
                w&nbsp;ochronie OC spowoduje on wypadek drogowy. Wówczas
                odszkodowanie pokrzywdzonym będzie musiał wypłacić
                z&nbsp;własnej kieszeni.
              </div>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Co robić, gdy mam wątpliwości przy korzystaniu
                z&nbsp;kalkulatora OC Mubi?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Na wszelkie pytania uzyskasz odpowiedź u&nbsp;naszych doradców.
                Jeśli podczas korzystania z&nbsp;kalkulatora OC i&nbsp;AC Mubi
                napotkasz na jakiekolwiek wątpliwości, zadzwoń pod numer
                22&nbsp;22&nbsp;10&nbsp;100. Konsultanci odpowiedzą na Twoje
                pytania, a&nbsp;w razie potrzeby pomogą dokończyć zakup polisy.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Czy zawsze warto kierować się tylko ceną podczas zakupu
                ubezpieczenia samochodu?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Jeśli szukasz tylko ubezpieczenia OC, rzeczywiście
                najkorzystniejszym krokiem będzie wybór najtańszej oferty.
                Zakres ochrony tej obowiązkowej polisy regulują przepisy,
                dlatego w&nbsp;każdym towarzystwie będzie taki sam.
                <br />
                <br />
                Nieco inaczej będzie w&nbsp;przypadku poszukiwania pakietów
                złożonych również z&nbsp;dobrowolnych polis. Zwykle obowiązuje
                zasada, że im tańsze oferty autocasco, NNW czy assistance, tym
                węższy zakres ochrony. Oznacza to, że ubezpieczenie AC może
                oferować naprawę przy wykorzystaniu części zamiennych zamiast
                oryginałów lub zapewniać ochronę tylko w&nbsp;razie zniszczeń
                spowodowanych przez siły natury. Z&nbsp;kolei NNW może mieć
                niższą sumę ubezpieczenia, a&nbsp;assistance – oferować
                np.&nbsp;holowanie w&nbsp;mniejszej odległości od miejsca
                zdarzenia. Zatem wybierając pakiet z&nbsp;ubezpieczeniem
                dobrowolnym w&nbsp;kalkulatorze OC i&nbsp;AC, najlepiej
                w&nbsp;pierwszej kolejności sprawdzić, czy oferowane świadczenia
                odpowiadają Twoim oczekiwaniom i&nbsp;potrzebom, wybrać te,
                które spełniają Twoje kryteria, a&nbsp;dopiero potem porównać je
                pod względem ceny.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Jakich dokumentów potrzebuję do wyliczenia ceny ubezpieczenia OC
                i&nbsp;AC samochodu w&nbsp;kalkulatorze?
              </h2>
              <p className={classes.expandableContentSectionParagraph}>
                Jeśli znasz parametry samochodu, numer rejestracyjny i&nbsp;dane
                wszystkich właścicieli oraz kierowców, będziesz mógł wyliczyć
                składkę ubezpieczenia OC i&nbsp;AC bez posiłkowania się
                dokumentami. Jeśli jednak potrzebujesz spisać numer
                rejestracyjny, dane pojazdu lub swoje z&nbsp;dokumentów,
                przygotuj dowód osobisty i&nbsp;dowód rejestracyjny pojazdu. Do
                wyliczenia składki ubezpieczenia OC w&nbsp;kalkulatorze może
                przydać Ci się też dotychczasowa polisa. Sprawdzisz w&nbsp;niej
                dokładną datę zakończenia ochrony. Dzięki temu łatwiej Ci będzie
                określić termin startu nowego ubezpieczenia, a&nbsp;tym samym
                uniknąć kary za przerwę w&nbsp;OC.
              </p>
            </div>
            <div
              className={classNames(
                classes.descriptionBox,
                classes.withBorderTop
              )}
            >
              <h2 className={classes.expandableContentSectionHeader3}>
                Jak wybrać tanie ubezpieczenie OC i&nbsp;AC na Mubi.pl?
              </h2>
              <div className={classes.expandableContentSectionParagraph}>
                Przede wszystkim porównując oferty. Jeśli zapoznasz się
                z&nbsp;ofertami wielu towarzystw, istnieje większe
                prawdopodobieństwo, że znajdziesz naprawdę tanią polisę OC
                i&nbsp;AC, niż wtedy, gdybyś wybierał spośród ofert tylko jednej
                firmy. Nie musisz jednak przeszukiwać stron każdego towarzystwa
                osobno. Żeby ułatwić sobie zadanie, posłuż się porównywarką OC
                i&nbsp;AC.
                <br />
                <br />
                Listę ofert w&nbsp;kalkulatorze OC Mubi możesz sortować od
                najtańszej do najdroższej. Dzięki temu łatwo znajdziesz
                najtańsze pakiety.
                <br />
                <br />
                Co wpływa na składkę ubezpieczeniową? Wiele parametrów pojazdu,
                jak chociażby marka czy pojemność silnika, ale także informacje
                o&nbsp;kierowcach i&nbsp;ich historii ubezpieczeniowej,
                np.&nbsp;wiek, miejsce zamieszkania, stan cywilny, liczba
                spowodowanych szkód. Na najtańsze ubezpieczenie OC mogą liczyć
                m.in.:
                <ul>
                  <li>
                    właściciel pojazdów z&nbsp;silnikami poniżej 1&nbsp;l,
                  </li>
                  <li>mieszkańcy niewielkich miejscowości,</li>
                  <li>małżonkowie,</li>
                  <li>osoby posiadające dzieci,</li>
                  <li>kierowcy powyżej 26.&nbsp;roku życia,</li>
                  <li>kierowcy z&nbsp;bezszkodową historią ubezpieczenia.</li>
                </ul>
              </div>
            </div>
          </div>
          <NewButton
            suffixIcon={ArrowUp}
            variant={'contained'}
            color={'primary'}
            onClick={() => {
              rootElement.current &&
                ScrollService.scrollToElement(rootElement.current, {
                  scrollToTop: true,
                });
            }}
            title={ButtonLabelEnum.Up}
            className={classes.backToBeginButton}
          />
        </div>
      </div>
    </div>
  );
}

export default QuestionsAndAnswers;
